
import { Vue, Component } from 'vue-property-decorator'
import { exportAreaGoods, TotalDataDTO, pullNewStatistics, exportPullNewForm } from '@/api/dataReport'
import { getFileName } from '@/utils/fileUtil'
import { exportFileWithData } from '@/utils/h5ToApp'
import DataSelect from '@/views/dataReport/template/dataSelect.vue'
import { GetOrganizationInfoAll } from '@/api/customerManage'
import { moneyFormat } from '@/utils/util'
import { Getter } from 'vuex-class'
import dayjs from 'dayjs'
import LineListCard from '@/views/dataReport/template/lineListCard.vue'

@Component(
    {
      components: {DataSelect, LineListCard}
    }
)
export default class EmployeeNew extends Vue {
  @Getter companyId!: string
  moneyFormat = moneyFormat
  readonly format = 'YYYY-MM-DD'

  queryParams = {
    startDate: dayjs().format(this.format),
    endDate: dayjs().format(this.format),
    deptId: '',
    employeeName: '',
    pageSize: 10,
    pageIndex: 1
  }

  depList = [] // 部门数据

  totalList = [
    {
      key: 'cusAmount',
      title: '总拉新客户'
    },
    {
      key: 'cusCount',
      title: '本期拉新客户'
    },
    {
      key: 'orderMoneyCount',
      title: '本期订货合计金额',
      type: 'money'
    },
    {
      key: 'unfinishMoneyAmount',
      title: '待完成订货全额合计',
      type: 'money'
    }
  ] // 退单统计列表

  totalData: TotalDataDTO | any = {} // 退单统计列表数据

  list = []
  listType = [
    {
      text: '本期拉新客户',
      key: 'cusCountOfEmp',
    },
    {
      text: '总拉新客户',
      key: 'cusAmountOfEmp'
    },
    {
      text: '待完成退货金额合计',
      key: 'unfinishRtnMoneyAmountOfEmp',
      type: 'money'
    },
    {
      text: '本期订货合计金额',
      key: 'orderMoneyCountOfEmp',
      type: 'money'
    },
    {
      text: '待完成退款金额合计',
      key: 'unfinishRtnAuditAmountOfEmp',
      type: 'money'
    },
  ]

  loading = false
  finished = false
  refreshing = false

  created () {
    this.getDepList()
    this.getListData()
  }

  load () {
    this.list = []
    this.finished = false
    this.queryParams.pageIndex = 1
    this.getListData()
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.refreshing = true
    this.load()
  }

  // 获取部门数据
  getDepList () {
    GetOrganizationInfoAll({}).then((res) => {
      this.depList = res.data
      this.depList.forEach(item => {
        if (item.isEnabled === '0' || item.orgType === '1') {
          item.disabled = true
        }
        item.value = item.orgId
        item.text = item.orgName
      })
      this.queryParams.deptId = this.depList[0].value
    })
  }

  getListData () {
    this.loading = true
    pullNewStatistics({
      ...this.queryParams
    }).then(res => {
      this.list = res.data.records
      if (this.list.length >= res.data.totalRecords) {
        this.finished = true
      }
      this.queryParams.pageIndex++
      this.initTotalData(res.data)
    }).finally(() => {
      this.loading = false
      this.refreshing = false
    })
  }

  initTotalData (data: TotalDataDTO) {
    this.totalData = {
      cusAmount: data.cusAmount,
      cusCount: data.cusCount,
      orderMoneyCount: data.orderMoneyCount,
      unfinishMoneyAmount: data.unfinishMoneyAmount
    }
  }

  /**
   * 头部总时间段改变
   * @param value
   */
  handleDataChange (value: Array<string>) {
    this.queryParams.startDate = value[0]
    this.queryParams.endDate = value[1]
    this.load()
  }

  /**
   * 导出
   */
  handleExport () {
    exportFileWithData({
      method: 'post',
      portUrl: '/cykjreport/OP/exportPullNewForm',
      params: JSON.stringify(Object.assign({companyId: this.companyId}, {...this.queryParams}))
    })
    exportPullNewForm({
      ...this.queryParams,
    }).then((res: any) => {
      if (res.data instanceof ArrayBuffer) {
        let params = {
          fileData: String.fromCharCode.apply(null, new Uint8Array(res.data)),
          fileName: getFileName(res.headers['content-disposition'])
        }
        // exportFileWithData({...params})
      }
    })
  }
}
